const KEY='yumnote.analytics.visitor.v1';
/** Anonymous browser/day counter. Failure never affects the app or local records. */
export function recordVisit():void {
  try {
    let visitor=localStorage.getItem(KEY);
    if(!visitor){visitor=crypto.randomUUID();localStorage.setItem(KEY,visitor);}
    const root=import.meta.env.DEV?'/api':'https://api.yumnote.ru';
    void fetch(`${root}/v1/analytics/visit`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({visitor}),keepalive:true}).catch(()=>{});
  }catch{/* No analytics must never block the app. */}
}
